import React, {Component} from 'react';
import LinksBar from './LinksBar';
import Copyright from './Copyright';
import CustomGrid from '../controls/grid/CustomGrid';
import Divider from '../controls/Divider';
import {Button} from 'components/controls';
import styles from './Footer.scss';
import classNames from 'classnames';
import CustomBox from 'components/controls/grid/CustomBox';
import SocialLinks from './SocialLinks';

export default class Footer extends Component {

    render() {

        return (
            <CustomGrid
                component="footer"
                className={styles.footer}
            >
                <CustomGrid
                    container
                    justify="space-between"
                >
                    <CustomGrid
                        item
                        md={6}
                        xs={12}
                        container
                    >
                        <CustomBox
                            m="xxl-2"
                        >
                            <LinksBar />
                        </CustomBox>
                    </CustomGrid>
                    <CustomGrid
                        item
                        md={6}
                        xs={12}
                        container
                        justify="flex-end"
                        alignItems="flex-end"
                    >
                        <CustomGrid
                            item
                        >
                            <CustomBox
                                m="xxl-2"
                            >
                                <SocialLinks />
                            </CustomBox>
                        </CustomGrid>
                    </CustomGrid>
                </CustomGrid>
                <CustomGrid
                    item
                    xs={12}
                >
                    <Divider />
                </CustomGrid>
                <Copyright />
            </CustomGrid>
        );
    }

    scrollTop = () => {
        const {scrollTop} = this.props;
        scrollTop();
    };
}



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js